/*
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-24 10:15:20
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-24 15:08:39
 * @FilePath: /wemeet-admin-new/src/api/recruitment/recommender.js
 * @Description:
 * Copyright (c) 2025 by WeMeet, All Rights Reserved.
 */
import request from '@/utils/request'

// 查询推荐人列表
export function getRecommenderList(data) {
  return request({
    url: '/user/admin/enterprise/job/recommend/list',
    method: 'POST',
    data,
  })
}

// 推荐人推荐详情
export function getRecommendDetail(data) {
  return request({
    url: '/user/admin/enterprise/job/recommend/detail',
    method: 'POST',
    data,
  })
}

// 推荐人更改状态
export function changeRecommendStatus(data) {
  return request({
    url: '/user/admin/enterprise/job/recommend/updateStatus',
    method: 'POST',
    data,
  })
}
